import gsap from 'gsap'

export default class Scroll{

  constructor(payload){
    // Check Instance
    this.scrollPosition = 0
    this.scrollDestination = 0

    this.maxNavigation = 0

    this.sizes = {
      windowWidth: 0,
      pageWidth: 0,
      scrollBarHeight: 0,
      scrollBarMapPixels: 0
    }
    this.scrollBarVisible = false

    this.container = payload.container
    this.lerp = 0.05
    this.scrollBar
    this.holdScrollBar = false
    this.pickUpPoint = 0
    this.gsapAnimation = null

    this.isTouchScreen = false

    this.createHtmlScroll()
    this.setMouseEvents()

    // Loop
    this.loop = () =>{
      if(this.container.scrollLeft != 0){
        this.toggleScrollBar(true)

        // Calculate Scroll
        const difference = this.scrollDestination - this.scrollPosition
        const movement = difference * this.lerp

        if(movement < -0.05 || movement > 0.05){
          this.scrollPosition += movement
          this.container.scrollLeft = this.scrollPosition

          // Update the scrollBar if not hold
          if(!this.holdScrollBar){
            this.updateScrollBarPosition()
          }
        }
        else{
          this.container.scrollLeft = this.scrollDestination
        }

        payload.setHorizontalPosition(this.sizes.windowWidth * (this.container.scrollLeft / this.sizes.pageWidth))
        window.requestAnimationFrame(this.loop)
      }
      else{
        payload.callBackToNavigation()
        this.toggleScrollBar(false)
      }

      payload.world.renderNavigation = this.container.scrollLeft < this.sizes.windowWidth
    }
  }

  setMouseEvents(){
    // Wheel Event
    window.addEventListener('wheel', event => {
      this.startEasingNavigation()

      this.updateSpeed(event)
    }, { passive: false })

    // TouchEvent
    let lastX = 0
    document.addEventListener('touchstart', event => {
      lastX = event.touches[0].clientX
      this.isTouchScreen = true
    })

    document.addEventListener('touchmove', event => {
      const newX = event.touches[0].clientX
      this.pushScrolling((lastX - newX) * 2)
      lastX = newX
    })

    // MouseEvent
    let hold = false
    document.addEventListener('mousedown', event => {
      lastX = event.clientX

      hold = true
    })
    document.addEventListener('dragend', () => {
      hold = false
    })

    this.scrollBar.addEventListener('mousedown', event => {
      this.startEasingNavigation()

      this.holdScrollBar = true
      document.body.style.userSelect = "none"

      // PickUp Point
      const box = this.scrollBar.getBoundingClientRect()
      this.pickUpPoint = event.clientY - box.top
    })

    // ScrollBar and MouseEvent
    document.addEventListener('mouseleave', () => {
      hold = false
      this.holdScrollBar = false
      this.container.style.userSelect = ""
    })
    document.addEventListener('mouseup', () => {
      hold = false
      this.holdScrollBar = false
      this.container.style.userSelect = ""
    })
    document.addEventListener('mousemove', event => {
      this.scrollBarDrag(event)

      if(hold){
        const newX = event.clientX
        this.pushScrolling((lastX - newX) * 2)
        lastX = newX
      }
    })
  }

  startEasingNavigation(){
    if(this.gsapAnimation){
      this.gsapAnimation.kill()
    }

    this.isTouchScreen = false
  }

  toggleScrollBar(visible){
    if(this.scrollBarVisible != visible) {
      this.scrollBar.style.display = visible && !this.isTouchScreen ? 'block' : 'none'
      this.scrollBarVisible = visible
    }
  }

  createHtmlScroll(){
    // Create new Scrollbar
    this.scrollBar = document.createElement('div')
    this.scrollBar.id = "scrollBar"

    this.container.appendChild(this.scrollBar)
  }

  resize(sizes){
    const projectBox = document.getElementById('project').getBoundingClientRect()
    this.sizes.windowWidth = sizes.width
    this.sizes.windowHeight = sizes.height
    this.sizes.pageWidth = projectBox.width

    // Resize Scroll bar
    this.maxNavigation = projectBox.width

    // Resize Scroll bar
    this.sizes.scrollBarHeight = sizes.height * (this.sizes.windowWidth / (projectBox.width + this.sizes.windowWidth) )

    this.scrollBarMapPixels = this.sizes.windowHeight - this.sizes.scrollBarHeight
    this.scrollBar.style.height = `${this.sizes.scrollBarHeight}px`
    this.updateScrollBarPosition()
  }

  updateScrollBarPosition(){
    // Scroll position
    const pageRatio = this.scrollDestination / (this.maxNavigation)
    this.scrollBar.style.top = `${(this.sizes.windowHeight - this.sizes.scrollBarHeight) * pageRatio}px`
  }

  updateSpeed(event){
    // Block defaut scrolling
    if(!event){ event = window.event }
    if(event.preventDefault) { event.preventDefault() }
    event.returnValue = false

    this.pushScrolling(event.deltaY)
  }

  pushScrolling(y){
    // Animate scrolling
    let newPosition = this.scrollDestination + y
    if(newPosition < 0){
      newPosition = 0
    }
    else if (newPosition > this.maxNavigation){
      newPosition = this.maxNavigation
    }

    this.scrollDestination = newPosition
  }

  scrollBarDrag(event){
    if(this.holdScrollBar){
      // Set ScrollBar Position
      let scrollBarPosition = event.clientY - this.pickUpPoint

      if(scrollBarPosition < 0 ){
        scrollBarPosition = 0
      }
      else if (scrollBarPosition > this.scrollBarMapPixels){
        scrollBarPosition = this.scrollBarMapPixels
      }
      this.scrollBar.style.top = `${scrollBarPosition}px`

      // Set Destinations
      const ratio = scrollBarPosition / (this.sizes.windowHeight - this.sizes.scrollBarHeight)

      this.scrollDestination = (this.maxNavigation) * ratio
    }
  }

  scrollTo(destination){
    const local = this
    // Animate
    let actualPosition = {
      x: this.container.scrollLeft
    }

    this.gsapAnimation = gsap.to(actualPosition,{
        x: destination,
        duration: 1,
        ease: "power2.inOut",
        onUpdate:function(){
          window.scrollTo(0, 0)
          local.container.scrollLeft = actualPosition.x

          local.scrollPosition = actualPosition.x
          local.scrollDestination = actualPosition.x

          local.updateScrollBarPosition()
        }
      }
    )
  }
}